import React from "react";
import Modal from "./Modal";

const LegalModal = ({ onClose, title, text }) => {
  return (
    <Modal onClose={onClose}>
      <div style={{ height: "100%", overflow: "auto" }}>
        {title && <h2>{title}</h2>}
        <pre style={{ whiteSpace: "pre-wrap", lineHeight: 1.6 }}>{text}</pre>
      </div>
    </Modal>
  );
};

export default LegalModal;


